import "../styles/main.scss"
import React from 'react';
import Home from '../pages/Home';
import Footer from "../components/Footer";
import Admin from "./Admin";
import News from "../pages/News";
import Nav from "../components/Nav";
import SingleNews from "../pages/SingleNews";
import Legal from "./Legal";
import NotFound from "./NotFound";
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Cars from "./Cars";
import Calendar from "./Calendar";
import Tablet from "./Tablet";
import QuizResults from "./QuizResults";

export default function App() {
  const location = useLocation();
  
    return (
      <>
        {location.pathname !== "/" && location.pathname !== "/tablet" && <Nav />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/SecretAdmin" element={<Admin />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<SingleNews />} />
          <Route path="/cars" element={<Cars />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/mentions-legales" element={<Legal />} />
          <Route path="/tablet" element={<Tablet />} />
          <Route 
            path="/content/votre-calendrier-dévénements" 
            element={<Navigate to="/calendar" replace />} 
          />
          <Route path="/SecretAdmin/quiz-results" element={<QuizResults />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {location.pathname !== "/tablet" && <Footer />}
      </>
    );
  }